// Instance.description owns artwork and edition formatting on the server.
export const formatWarehouseDescription = (warehouseItems = []) =>
  warehouseItems
    .map(item =>
      [
        item.id || "",
        item.category?.description || "",
        `${item.dimh || "0"} x ${item.dimw || "0"} x ${item.dimd || "0"} cm`,
        item.instance?.description || "",
      ].join("\n"),
    )
    .join("\n\n");
